/*
 * Copyright (C) 2013 Minted Inc.
 *
 * All Rights Reserved
 *
 * CTAG:COMMUNITY:CHALLENGES
 */

(function (M, _, $, Backbone) {
  "use strict";

  M.View = M.View || {};
  M.View.Design = M.View.Design || {};

  /**
   * @class M.View.Design.PollVoteSuccess
   * Displays a dialog soliciting a comment after the user successfully voted
   * in the poll
   */
  M.View.Design.PollVoteSuccess = Backbone.View.extend({
    tagName: 'div',
    className: 'pollVoteSuccessDialog',
    events: {
      'click .cancel': 'close',
      'click .submitComment': 'submitComment'
    },

    template: M.Template.Design.PollVoteSuccess,

    initialize: function() {
      this.$el = $(this.el);
    },

    render: function() {
      this.$el.html(this.template({
        thumb: this.model.get('option').get('thumb'),
        optionName: this.options.optionView.name
      }));
      this.$el.dialog({
        title: 'great, thanks! do you have any comments on this design?',
        modal: true,
        width: 500,
        draggable: false,
        close: _.bind(this.close, this)
      });
      this.textarea = this.$('textarea');
    },

    submitComment: function() {
      var text = this.textarea.val();
      if (text) {
        var comment = new M.Model.CommunityComment({
          text: this.textarea.val(),
          design_id: this.options.poll.get('design').id,
          // currently only pass-through to community comment model
          urlPaths: this.options.urlPaths
        });
        // Save the comment and reload page when done.
        comment.save().then(
          _.bind(this.close, this),
          function() {
            alert("Failed to save comment. Please try again.");
          }
        );
      } else {
        this.close();
      }
    },

    close: function() {
      // Reload the page unconditionally on close, because we need to display
      // the user's vote as well is the comment they made (if any).
      location.reload();
    }
  });

})(M, _, $, Backbone);

